import { DialogButton } from '@beeinventor/dasiot-react-component-lib';
import { Box, Popover, styled, Typography } from '@mui/material';
import { Add, Search } from '@mui/icons-material';
import { useMemo, useState } from 'react';
import { FixedSizeList } from 'react-window';
import Input from '../../../components/TextField/Input';
import ErrorMessage from './ErrorMessage';

const Title = styled(Typography)(({ theme }) => ({
  ...theme.externalTypography.body3,
  color: theme.color.secondary.$60,
}));

interface AddSettingButtonProps {
  setInputItems: (value: string) => void;
  selectedSchema: string | undefined;
  settingList: {
    name: string;
    value: string;
  }[];
  errorMessage: string | undefined;
}

const ContainerAddItems = styled('li')`
  width: 100%;
  vertical-align: middle;
  :hover {
    background-color: #ffb905;
  }
`;

const AddSettingButton: React.FC<AddSettingButtonProps> = ({
  setInputItems,
  selectedSchema,
  settingList,
  errorMessage,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const [filterText, setFilterText] = useState<string>('');

  const handleCloseAddPopup = () => {
    setAnchorEl(null);
  };

  const filtersettingList = useMemo(() => {
    if (filterText !== '') {
      return settingList.filter((d) => {
        return d.name.toLowerCase().includes(filterText.toLowerCase());
      });
    } else {
      return settingList;
    }
  }, [filterText, settingList, selectedSchema]);

  const settingListHtml = useMemo(() => {
    if (filtersettingList.length) {
      return (
        <FixedSizeList
          itemSize={55}
          itemCount={filtersettingList.length}
          height={300}
          width={320}
          // overscanCount={10}
          // style={{ padding: '8px' }}
        >
          {({ index, style }) => {
            const item = filtersettingList[index];
            if (!item) {
              return null;
            }
            return (
              <ContainerAddItems
                style={{
                  ...style,
                  padding: '0px 4px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  display: 'flex',
                  alignItems: 'center',
                  verticalAlign: 'middle',
                  width: '100%',
                  height: '55px',
                }}
                onClick={() => {
                  handleCloseAddPopup();
                  setInputItems(item.value);
                }}
              >
                {item.value}
              </ContainerAddItems>
            );
          }}
        </FixedSizeList>
      );
    }
  }, [filtersettingList, selectedSchema]);

  return (
    <Box>
      <Title>Fix</Title>
      <DialogButton
        variant="contained"
        color="primary"
        onClick={handleClick}
        sx={{ height: '40px', alignSelf: 'flex-end', width: '100%' }}
        endIcon={<Add />}
        disabled={selectedSchema === undefined ? true : false}
      >
        ADD
      </DialogButton>
      <Popover
        id=""
        open={open}
        anchorEl={anchorEl}
        onClose={() => handleCloseAddPopup()}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ overflowY: 'hidden', '& MuiPaper-root': { padding: '8px' } }}
      >
        <Input
          value={filterText}
          onChange={(event) => {
            setFilterText(event.target.value);
          }}
          startAdornment={<Search />}
        />
        {settingListHtml}
      </Popover>
      {errorMessage && <ErrorMessage message={errorMessage} />}
    </Box>
  );
};

export default AddSettingButton;
